/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
      // JavaScript to be fired on all pages

				navbarScrollhide();

				// position:sticky polyfill
				$('.sharedaddy, .sticky_top, .widget_sticky').Stickyfill();

				// Global utility
				// I hope this isn't expensive
				$('body')
					.on( 'click', '.preventDefault', function(e){
						e.preventDefault();
					});

				// Navbar listeners
				$('#navbar')
					// Toggle logo dropdown
					.on( 'click', 'a.navbar-brand', function(){
						var $logo_dropdown = $('#logo-dropdown');
						if ( $logo_dropdown.length > 0 ) {
							$('#logo-dropdown').toggleClass('active');
							return false;
						}
					} )

					// Close logo dropdown
					.on( 'click', '#close-logo-dropdown', function(){
						$('#logo-dropdown').removeClass('active');
						return false;
					} )

					// Toggle search in nav
					.on( 'mousedown', '#toggle-search', function(){

						var $navbar_search_query = $('#navbar-search-query');
						$navbar_search_query.toggleClass('active');

						if ( $navbar_search_query.hasClass('active') ) {
							$navbar_search_query.find('input').focus();
						}

						return false;
					} )
					.on( 'click', '#toggle-search', function(){
						return false;
					} )

					// Hide search when clicked outside
					.on( 'blur', '#navbar-search-query input', function(){
							$('#navbar-search-query').removeClass('active');
					} )

					// Toggle dropdowns on mobile menu
					.on( 'click', '.menu-item-has-children > a.open-sub-menu', function(e){

						$('#navbar ul.sub-menu').height(0);

						var $submenu = $(this).next('ul.sub-menu');
						var total_height = 0;

						if ( $submenu.outerHeight() === 0 ) {
							$submenu.children('li').each(function(){
								total_height += $(this).outerHeight();
							});
							$submenu.height(total_height);
						}

						return false;
					} );

				// Create extra anchor for mobile menu dropdowns
				$('#navbar .sub-menu').before('<a href="#" class="open-sub-menu nav-link"></a>');

				// Main menu collapse listener
				$('#main-menu')
					.on( 'show.bs.collapse', function () {
						$('html, body').addClass('main-menu-open');
					} )
					.on( 'hidden.bs.collapse', function () {
						$('html, body').removeClass('main-menu-open');
					} );

				// Swipe support on carousel in jumbotron
				$('#jumbosel')
					.swiperight( function() {
						$(this).carousel('prev');
					} )
					.swipeleft( function() {
						$(this).carousel('next');
					} );

				// Turn on bootstrap tooltips (what?)
				$('[data-toggle="tooltip"]').tooltip();

				// Move chapters widget above content on mobile
				$('.widget_chapters_widget').clone().prependTo('.col-entry');

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    'single': {
      init: function() {
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
